import React, { useState, useEffect } from 'react';
import { Table, Select, DatePicker, Input, Space, Button, ConfigProvider, message, Pagination, Tooltip } from 'antd';
import dayjs from 'dayjs';
import styles from './Table.module.scss';
import GoBack from '../../../compoents/goBack/goBack';
import { useNavigate } from 'react-router-dom';
import api from '../../../../api/api';
import ExpandedRow from '../ExpandTable/ExpandTable';
import PSAIModal from '../../../../PSAIComponents/PSAIModal';
import datepickerIcon from '@assets/images/datepicker_icon.png'
import eventBus from '../../../../utils/eventBus';

const { Option } = Select;

const AntdTable = (props) => {
  const {getisSpinning} = props
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState();
  const [statusFilter, setStatusFilter] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [pageSize, setPageSize] = useState(7); //分页用
  const [pageIndex, setPageIndex] = useState(1); //分页用
  const [total, setTotal] = useState(0); // 总数据条数
  const [expendOrderId, setExpendOrderId] = useState();
  const mapStatus = (status) => {
    switch (status) {
      case 1: return '待确认';
      case 2: return '进行中';
      case 3: return '已完成';
      case 4: return '已拒绝';
      default: return '待确认';
    }
  };
  const fetchData = async (pageSize, pageIndex, status, start, end) => {
    try {
      getisSpinning(true)
      const response = await api.listOrder({
        pageIndex: pageIndex,
        pageSize: pageSize,
        status: status, // 订单状态
        start: start ? dayjs(start).format('YYYY-MM-DD') : undefined, // 开始日期
        end: end ? dayjs(end).format('YYYY-MM-DD') : undefined, // 结束日期
      });
      getisSpinning(false)
      if(response.code != 0) {
        message.warning(response.message)
        return false
      }
      const rawData = response.data.items;
      setTotal(response.data.total); // 设置总数据条数
      const formattedData = rawData?.map(item => ({
        key: item.orderId,
        orderId: item.id,
        product: item.deliveryType,
        skuCount: item.skuCount,
        deliveredCount: item.baseImageCount,
        retouchedCount: item.finishCount,
        retouchTimes: item.refinedTimes,
        totalPrice: item.totalPrice,
        deliveryDate: item.deliveryTime,
        deadline: item.endTime,
        status: mapStatus(item.status),
        frontPrice:item.frontPrice,
        endPrice:item.endPrice,
      }));
      setData(formattedData); // 原始数据
      setFilteredData(formattedData); // 带筛选条件的数组
    } catch (error) {
      console.error('数据获取失败:', error);
    }
  };
  // console.log('data', data);
  //分页
  const fetchMoreData = async (pageIndex) => {
    setPageIndex(pageIndex);
    // fetchData(pageSize, pageIndex);
    fetchData(pageSize, pageIndex, statusFilter, startDate, endDate); 
    // filterData();
    console.log(pageIndex);
  };
  //选择状态、日期时时直接触发筛选（备选^^）
  // //状态筛选
  // const handleStatusChange = (value) => {
  //   setStatusFilter(value);
  //   fetchData(pageSize, pageIndex, value, startDate, endDate);
  // };

  // //日期筛选
  // const handleStartDateChange = (date) => {
  //   setStartDate(date);
  //   fetchData(pageSize, pageIndex, statusFilter, date, endDate);
  // };
  // const handleEndDateChange = (date) => {
  //   setPageIndex(1);//避免在非第一页筛选，没有数据的情况
  //   const startDateDayjs = dayjs(startDate).startOf('day');
  //   const endDateDayjs = dayjs(date).startOf('day');
  //   if (endDateDayjs.isAfter(startDateDayjs) || endDateDayjs.isSame(startDateDayjs)) {
  //     setEndDate(date);
  //     fetchData(pageSize, pageIndex, statusFilter, startDate, date);
  //   } else {
  //     console.log('开始日期应早于结束日期');
  //     message.error('开始日期应早于结束日期');
  //     setEndDate('');
  //     setStartDate('');
  //   }
  // };
  // useEffect(() => {
  //   fetchData(pageSize, pageIndex, statusFilter, startDate, endDate);
  // }, [pageSize, pageIndex, statusFilter, startDate, endDate]);


  // const handleReset = () => {
  //   setStatusFilter('');
  //   setStartDate(null);
  //   setEndDate(null);
  //   setSearchTerm('');
  //   setFilteredData(data);
  // };
    //状态筛选
    const handleStatusChange = (value) => {
      setStatusFilter(value); 
    };
  
    //日期筛选
    const handleStartDateChange = (date) => {
      if (!date) { 
        setStartDate(null);
        return; 
      }
      setStartDate(date); 
    };
  
    const handleEndDateChange = (date) => {
      if (!date) { 
        setEndDate(null);
        return; 
      }
      setEndDate(date);
    };
    
    const handleSearch = () => {
      setPageIndex(1); // 搜索时重置分页
      fetchData(pageSize, 1, statusFilter, startDate, endDate); 
    };
  
    const handleReset = () => {
      setStatusFilter('');
      setStartDate(null);
      setEndDate(null);
      setSearchTerm('');
      fetchData(pageSize, 1, '', null, null); 
    };
    useEffect(() => {
      fetchData(pageSize, pageIndex, statusFilter, startDate, endDate); 
    }, [pageSize, pageIndex]);
  // 搜索框
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    console.log(e.target.value);
  };

  //确认、拒绝二次弹窗
  const [confirmModal ,setConfirmModal] = useState(false);
  const [confirmModal2 ,setConfirmModal2] = useState(false);
  const [confirmId ,setConfirmId] = useState();
  const [confirmStatus , setConfirmStatus] = useState();
  const handleConfirmModal = (status ,id)=>{
    setConfirmId(id);
    setConfirmStatus(status);
    setConfirmModal(true);
  }
  const handleConfirmModal2 = (status ,id)=>{
    setConfirmId(id);
    setConfirmStatus(status);
    setConfirmModal2(true);
  }
  //确认(status===2)、拒绝订单(status===4)
  const handleConfirm = async (status, id) => {
    try {
      const response = await api.confirmOrder({
        orderId: id,
        status: status,
      });
      console.log(response);
      if (response.code == 0) {
        if (status == 2) {
          console.log('用户确认订单');
          message.success('订单已确认!');
          setConfirmModal(false);
          setConfirmModal2(false);
          setConfirmId();
          setConfirmStatus();
          eventBus.emit('updatePower');
          eventBus.emit('statusUpdated'); 
        } else {
          console.log('用户拒绝订单');
          message.success('订单已拒绝');
          setConfirmModal(false);
          setConfirmModal2(false);
          setConfirmId();
          setConfirmStatus();
          eventBus.emit('updatePower');
          eventBus.emit('statusUpdated'); 
        }
        fetchData(pageSize, pageIndex)
      } else {
        setConfirmId();
        setConfirmStatus();
        setConfirmModal(false);
        setConfirmModal2(false);
        message.error(response.message);
        console.log(response.code, response.message);
      }
    } catch (error) {
      console.log(error);
    } finally{
    setConfirmId();
    setConfirmStatus();
    setConfirmModal(false);
    setConfirmModal2(false);
    eventBus.emit('updatePower');
    eventBus.emit('statusUpdated'); 
    }
  }  
  //筛选
  const filterData = () => {
    let filtered = data;
    if (searchTerm) {
      filtered = filtered.filter((item) =>
        item.orderId.includes(searchTerm)
      );
    }
    setFilteredData(filtered);
  }

  const navigate = useNavigate();
  const columns = [
    {
      title: '订单编号',
      dataIndex: 'key',
      key: 'key',
      align: 'center',
      ellipsis: true,
      render:(text , record) =>{
        const key = record.key;
        return(
          <Tooltip placement='topLeft' title={key}>
          <span>{key}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '交付物',
      dataIndex: 'product',
      key: 'product',
      align: 'center',
      ellipsis: true,
    },
    // {
    //   title: '需求数量',
    //   dataIndex: 'skuCount',
    //   key: 'skuCount',
    //   align: 'center',
    // },
    {
      title: '底片数量',
      dataIndex: 'deliveredCount',
      key: 'deliveredCount',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '成片数量',
      dataIndex: 'retouchedCount',
      key: 'retouchedCount',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '精修次数',
      dataIndex: 'retouchTimes',
      key: 'retouchTimes',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '总价',
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      align: 'center',
      ellipsis: true,
      width:140,
      render: (text, record) => {
        const frontPrice = record.frontPrice;
        const endPrice = record.endPrice;
        return (
          <span style={{display:'flex', alignItems:'center' ,justifyContent:'center'}}>{record.totalPrice}虹豆
            <Tooltip overlayClassName={styles.tooltip} placement="top" title={`定金${frontPrice}虹豆，尾款${endPrice}虹豆`}>
              <img style={{ display: 'inline-block', width: '16px', height: '16px', marginLeft: '4px' }} src={require('@assets/images/totalPrice_icon.png')} />
            </Tooltip>
          </span>
        )
      }
    },
    {
      title: '交付日期',
      dataIndex: 'deliveryDate',
      key: 'deliveryDate',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => dayjs(a.deliveryDate).unix() - dayjs(b.deliveryDate).unix(),
      render:(text , record) =>{
        const deliveryDate = record.deliveryDate;
        return(
          <Tooltip placement='topLeft' title={deliveryDate}>
          <span>{deliveryDate}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '订单截止日期',
      dataIndex: 'deadline',
      key: 'deadline',
      align: 'center',
      ellipsis: true,
      sorter: (a, b) => dayjs(a.deadline).unix() - dayjs(b.deadline).unix(),
      render:(text , record) =>{
        const deadline = record.deadline;
        return(
          <Tooltip placement='topLeft' title={deadline}>
          <span>{deadline}</span>
          </Tooltip>
        )
      }
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width:130,
      render: (text, record) => {
        const getImageSrc = () => {
          switch (record.status) {
            case '进行中':
              return require('@assets/images/pendding.png');
            case '已拒绝':
              return require('@assets/images/refused.png');
            case '已完成':
              return require('@assets/images/complete.png');
            default:
              return require('@assets/images/tobeConfirm.png');
          }
        };
        return (
          <div className={`${styles.status_container} ${record.status === '已完成' ? styles.default_status : record.status === '已拒绝' ? styles.refused : record.status === '进行中' ? styles.remain : record.status === '已拒绝' ? styles.refused : styles.unconfirmed}`}>
            <img className={styles.status_img} src={getImageSrc()} alt="" />
            <span style={{ paddingRight: '4px' }}>{record.status}</span>
          </div>
        )
      }
    },
    // {
    //   title: '订单详情',
    //   key: 'details',
    //   align: 'center',
    //   render: (text, record) => (
    //     <a onClick={() => navigate('/home/homemain/image_service/details', { state: record })}>查看</a>
    //   ),
    // },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      // ellipsis: true,
      width:152,
      render: (text, record) => {
        // console.log(record);
        if (record.status === '待确认') {
          const id = record.orderId;
          return (
            <div className={styles.confirm_container}>
              <Button type="danger" size="small" style={{ marginRight: 8 }} onClick={()=> handleConfirmModal(2,id)}>
                确认
              </Button>
              <Button type="danger" size="small" onClick={()=> handleConfirmModal2(4,id)}>
                拒绝
              </Button>
            </div>
          );
        } 
        // else if (record.status === '进行中' ) {
        //   return <a onClick={() => navigate('/home/homemain/image_service/deliver', { state: record })}>查看图集</a>
        // } 
        else {
          return '-';
        }
      },
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <div className={styles.search_container}>
        <span className={styles.select_text}>订单状态</span>
        <ConfigProvider
          theme={{
            token: {
              colorBgContainer: '#F8F9FF',
            },
          }}>
          <Select
            placeholder="请选择"
            value={statusFilter}
            onChange={handleStatusChange}
            style={{ width: '2.64rem' }}
            className={styles.select_container}
          >
            <Option value="">全部状态</Option>
            <Option value='1'>待确认</Option>
            <Option value="2">进行中</Option>
            <Option value="3">已完成</Option>
            <Option value="4">已拒绝</Option>
          </Select>
        </ConfigProvider>
        <span className={styles.date_filter_text}>底片交付日期</span>
        <ConfigProvider
          theme={{
            token: {
              colorBgContainer: '#F8F9FF',
            },
          }}>
          <DatePicker
            placeholder="请选择开始日期"
            value={startDate}
            onChange={handleStartDateChange}
            suffixIcon={<div><img src={datepickerIcon} alt="选择开始日期" style={{width:"24px", height:'24px'}} /></div>}
            style={{ width: '2.64rem' }}
          />
        </ConfigProvider>
        <span className={styles.date_filter_text2}>至</span>
        <ConfigProvider
          theme={{
            token: {
              colorBgContainer: '#F8F9FF',
            },
          }}>
          <DatePicker
            placeholder="请选择结束日期"
            value={endDate}
            onChange={handleEndDateChange}
            suffixIcon={<div><img src={datepickerIcon} alt="选择开始日期" style={{width:"24px", height:'24px'}} /></div>}
            style={{ width: '2.64rem' }}
          />
        </ConfigProvider>
        <span>
          <span className={styles.empty_block}></span>
          {/* <ConfigProvider
            theme={{
              token: {
                colorBgContainer: '#F8F9FF',
              },
            }}
          >
            <Input
              placeholder="搜索订单编号"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: 200 }}
            />
          </ConfigProvider> */}
          <button className={styles.search_btn} onClick={handleSearch}>
            搜索
          </button>
          <img style={{marginLeft:'.1rem',marginBottom:'.05rem', width: '24px', height: '24px', cursor: 'pointer', display: 'inline-block' }} src={require('@assets/images/reset_btn.png')} alt="重置所有选项" onClick={handleReset} />
        </span>
        {/* <Button onClick={handleReset} className={styles.reset_btn}>恢复</Button> */}
      </div>
      <ConfigProvider
        theme={{
          token: {
            headerSortActiveBg: '#F5F6FC',
          }
        }}
      >
        <Table
          columns={columns}
          dataSource={filteredData}
          expandable={{
            expandedRowRender: (record) => <ExpandedRow orderId={record.orderId} />,
            defaultExpandedRowKeys: ['0'],
          }}
          pagination={{
            position: ['bottomCenter'],
            hideOnSinglePage: true,
            pageSize: pageSize,
            current: pageIndex,
            total: total,
            onChange: fetchMoreData, //分页用
          }}
          className={styles.table}
        />
      </ConfigProvider>

      <PSAIModal
        title={'是否确认订单'}
        closeIcon={null}
        open={confirmModal}
        maxWidth={500}
        cancelText='取消'
        onCancel={()=> setConfirmModal(false)}
        okText='确认'
        onOk={()=> handleConfirm(confirmStatus, confirmId)}
      >
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", fontSize:"16px", paddingTop:"20px", fontWeight:"600"}}>确认后将扣除订单定金</div>
      </PSAIModal>

      <PSAIModal
        title={'是否拒绝订单'}
        closeIcon={null}
        open={confirmModal2}
        maxWidth={500}
        cancelText='取消'
        onCancel={()=> setConfirmModal2(false)}
        okText='确认拒绝'
        onOk={()=> handleConfirm(confirmStatus, confirmId)}
      >
        <div style={{display:"flex", justifyContent:"center", alignItems:"center", fontSize:"16px", paddingTop:"20px", fontWeight:"600"}}>拒绝后此订单失效</div>
      </PSAIModal>
    </div>
  );
};
export default AntdTable;